export default __webpack_public_path__ + "static/media/MH_2.87fd2b2b.png";